import React, { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSavedState } from "../utils/localStorage";
import { localStorageKeys } from "../constant/app.constant";
import { hasPermission } from "../utils/helpers/permissions";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermissions: string[];
  allowedOrgTypes?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermissions, allowedOrgTypes }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getSavedState(localStorageKeys.CharterUser);

    if (!auth.data) {
      navigate("/");
      return;
    }

    const userPermissions = auth?.data?.permissions || [];
    

    const hasAccess = hasPermission(
      userPermissions,
      requiredPermissions,
      allowedOrgTypes!,
      auth?.data?.organizationType
    );

    if (!hasAccess) {
      navigate("/");
    }
  }, [navigate, requiredPermissions, allowedOrgTypes]);

  return <>{children}</>;
};

export default ProtectedRoute;
